import * as React from 'react';
import styled from 'styled-components';
import RectangleButton from 'src/components/Buttons/RectangleButton';
import Col from 'reactstrap/lib/Col';
import { withRouter, RouteComponentProps } from 'react-router-dom';

const GetStartedFooterContainer = styled.div`
  width: 100%;
  height: 100px;
  background: #00144d;
  padding-left: 45px;
  padding-right: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding-left: 22px;
  }

  position: sticky;
  bottom: 0px;
`;

const GetStartedFooterText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: normal;

  color: #ffffff;
  margin-bottom: 0px !important;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const GetStartedFooter = (props: RouteComponentProps<any>) => {
  return (
    <GetStartedFooterContainer>
      <Col xs={{ offset: 0, size: 9 }}>
        <GetStartedFooterText>Book your summer storage now.</GetStartedFooterText>
      </Col>

      <RectangleButton
        inverted
        style={{ width: 148 }}
        onClick={() => props.history.push('/getting-started')}
      >
        Get Started
      </RectangleButton>
    </GetStartedFooterContainer>
  );
};

export default withRouter(GetStartedFooter);



// WEBPACK FOOTER //
// ./src/pages/AboutUs/components/GetStartedFooter.tsx